import { render, staticRenderFns } from "./ScheduleSetup.vue?vue&type=template&id=ebef8f42&scoped=true&"
import script from "./ScheduleSetup.vue?vue&type=script&lang=ts&"
export * from "./ScheduleSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebef8f42",
  null
  
)

export default component.exports